import {hashCodeCertificate} from "./hoc/hashCodeCertificate";

const WaybillV2BulkReturnAccepted = hashCodeCertificate('WaybillV2ReturnAccepted')
export default WaybillV2BulkReturnAccepted